import { render } from "./TampleteList.vue?vue&type=template&id=5600e80a&scoped=true"
import script from "./TampleteList.vue?vue&type=script&lang=js"
export * from "./TampleteList.vue?vue&type=script&lang=js"

import "./TampleteList.vue?vue&type=style&index=0&id=5600e80a&lang=less&scoped=true"

import exportComponent from "E:\\qq\\前端(1)\\前端\\后台vue\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5600e80a"]])

export default __exports__